import { Routes, Route, Link, Navigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { LanguageSwitcher } from './components/LanguageSwitcher.js';
import { Register } from './pages/Register.js';
import { VerifySent } from './pages/VerifySent.js';
import { Verify } from './pages/Verify.js';
import { Login } from './pages/Login.js';
import { Invite } from './pages/Invite.js';
import { Dashboard } from './pages/Dashboard.js';
import { Onboarding } from './pages/Onboarding.js';
import { CaseIntake } from './pages/CaseIntake.js';
import { Impressum } from './pages/Impressum.js';
import { Datenschutz } from './pages/Datenschutz.js';
import { Erstgespraech } from './pages/Erstgespraech.js';
import { NotFound } from './pages/NotFound.js';

export function App() {
  const { t } = useTranslation();
  return (
    <div className="layout">
      <header className="layout-header">
        <div className="layout-header-inner">
          <Link to="/" className="layout-header-link">
            <div>
              <h1 className="layout-header-title">{t('nav.title')}</h1>
              <p className="layout-header-subtitle">{t('nav.subtitle')}</p>
            </div>
            <img src="/gql-logo.svg" alt="GQL" className="layout-header-logo" />
          </Link>
          <LanguageSwitcher />
        </div>
      </header>
      <main className="layout-main">
        <Routes>
          <Route path="/" element={<Navigate to="/register" replace />} />
          <Route path="/register" element={<Register />} />
          <Route path="/verify-sent" element={<VerifySent />} />
          <Route path="/verify" element={<Verify />} />
          <Route path="/login" element={<Login />} />
          <Route path="/invite" element={<Invite />} />
          <Route path="/dashboard" element={<Dashboard />} />
          <Route path="/onboarding" element={<Onboarding />} />
          <Route path="/intake" element={<CaseIntake />} />
          <Route path="/impressum" element={<Impressum />} />
          <Route path="/datenschutz" element={<Datenschutz />} />
          <Route path="/erstgespraech" element={<Erstgespraech />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </main>
      <footer className="layout-footer">
        <Link to="/impressum">{t('nav.impressum')}</Link>
        <span className="layout-footer-sep">·</span>
        <Link to="/datenschutz">{t('nav.datenschutz')}</Link>
        <span className="layout-footer-sep">·</span>
        <a href="https://www.gql-partner.de" target="_blank" rel="noreferrer">gql-partner.de</a>
      </footer>
    </div>
  );
}
